import { InstanceLink } from '~/components/Details/InstanceDetails/MenuInstances';
import { ObjectLiteral } from '~/types/generics';

import { IProcessFile, IProcessXmlFormFieldParsed } from '../processes/types';
import { IUser } from '../users/types';
import {
  ICancelingReasonData,
  ITask,
  ITaskData,
  ITaskHistory,
  ITaskTypes,
  ITaskRankingPosition,
  ITaskInstanceCount,
  IGetTasksParams,
  IGetTasksRequestAction,
  IFailure,
} from './types';

export function changeTasksFilterRequest(
  filter: 'unassigned' | 'assignee' | 'assigneeNotIn' | 'finished',
) {
  return {
    type: ITaskTypes.CHANGE_TASKS_FILTER_REQUEST,
    payload: { filter },
  };
}

export function getTasksRequest(params: IGetTasksParams, user?: IUser) {
  return {
    type: ITaskTypes.GET_TASKS_REQUEST,
    payload: { params, user },
  };
}
export function getTasksSuccess(
  sortOrder: 'asc' | 'desc',
  tasks: ITask[],
  count: ITaskInstanceCount,
) {
  return {
    type: ITaskTypes.GET_TASKS_SUCCESS,
    payload: { sortOrder, tasks, count },
  };
}
export function getTasksFailure() {
  return {
    type: ITaskTypes.GET_TASKS_FAILURE,
  };
}

export function getCompletedTasksRequest(
  params: {
    page: number;
    limit: number;
    [key: string]: any;
  },
  changeOrder: boolean,
) {
  return {
    type: ITaskTypes.GET_COMPLETED_TASKS_REQUEST,
    payload: { params, changeOrder },
  };
}
export function getCompletedTasksSuccess(
  sortOrder: 'asc' | 'desc',
  completedTasks: ITaskHistory[],
  totalCompletedTasks: number,
) {
  return {
    type: ITaskTypes.GET_COMPLETED_TASKS_SUCCESS,
    payload: { sortOrder, completedTasks, totalCompletedTasks },
  };
}
export function getCompletedTasksFailure() {
  return {
    type: ITaskTypes.GET_COMPLETED_TASKS_FAILURE,
  };
}

export function getDeletedTasksRequest(
  params: {
    page: number;
    limit: number;
    [key: string]: any;
  },
  changeOrder: boolean,
) {
  return {
    type: ITaskTypes.GET_DELETED_TASKS_REQUEST,
    payload: { params, changeOrder },
  };
}
export function getDeletedTasksSuccess(
  sortOrder: 'asc' | 'desc',
  deletedTasks: ITaskHistory[],
  totalDeletedTasks: number,
) {
  return {
    type: ITaskTypes.GET_DELETED_TASKS_SUCCESS,
    payload: { sortOrder, deletedTasks, totalDeletedTasks },
  };
}
export function getDeletedTasksFailure() {
  return {
    type: ITaskTypes.GET_DELETED_TASKS_FAILURE,
  };
}

export function getTasksHistoryAllRequest(
  params: {
    page: number;
    limit: number;
    [key: string]: any;
  },
  changeOrder: boolean,
) {
  return {
    type: ITaskTypes.GET_TASKS_HISTORY_ALL_REQUEST,
    payload: { params, changeOrder },
  };
}
export function getTasksHistoryAllSuccess(
  sortOrder: 'asc' | 'desc',
  tasksHistoryAll: ITaskHistory[],
  totalTasksHistoryAll: number,
) {
  return {
    type: ITaskTypes.GET_TASKS_HISTORY_ALL_SUCCESS,
    payload: { sortOrder, tasksHistoryAll, totalTasksHistoryAll },
  };
}
export function getTasksHistoryAllFailure() {
  return {
    type: ITaskTypes.GET_TASKS_HISTORY_ALL_FAILURE,
  };
}

export function getTasksHistoryCountRequest() {
  return {
    type: ITaskTypes.GET_TASKS_HISTORY_COUNT_REQUEST,
  };
}
export function getTasksHistoryCountSuccess(totalTasksHistory: string) {
  return {
    type: ITaskTypes.GET_TASKS_HISTORY_COUNT_SUCCESS,
    payload: { totalTasksHistory },
  };
}
export function getTasksHistoryCountFailure() {
  return {
    type: ITaskTypes.GET_TASKS_HISTORY_COUNT_FAILURE,
  };
}

export function resetTaskAssignedError() {
  return {
    type: ITaskTypes.RESET_TASK_ASSIGNED_ERROR,
  };
}

export function unclaimTaskRequest(
  taskIds: Array<string>,
  getTasksParams: IGetTasksRequestAction['payload'],
) {
  return {
    type: ITaskTypes.UNCLAIM_TASK_REQUEST,
    payload: { taskIds, getTasksParams },
  };
}
export function unclaimTaskSuccess() {
  return {
    type: ITaskTypes.UNCLAIM_TASK_SUCCESS,
  };
}
export function unclaimTaskFailure(failures: Array<IFailure>) {
  return {
    type: ITaskTypes.UNCLAIM_TASK_FAILURE,
    payload: { failures },
  };
}

export function getTaskRequest(id: string, executeTask?: boolean) {
  return {
    type: ITaskTypes.GET_TASK_REQUEST,
    payload: { id, executeTask },
  };
}
export function getTaskSuccess(task: ITaskHistory, executeTask?: boolean) {
  return {
    type: ITaskTypes.GET_TASK_SUCCESS,
    payload: { task, executeTask },
  };
}
export function getTaskFailure(errorStatus: number) {
  return {
    type: ITaskTypes.GET_TASK_FAILURE,
    payload: {
      errorStatus,
    },
  };
}

export function claimTaskRequest(
  taskIds: Array<string>,
  userId: number,
  managerId: number,
  getTasksParams: IGetTasksRequestAction['payload'],
  reassignee?: true,
) {
  return {
    type: ITaskTypes.CLAIM_TASK_REQUEST,
    payload: { taskIds, userId, managerId, getTasksParams, reassignee },
  };
}
export function claimTaskSuccess() {
  return {
    type: ITaskTypes.CLAIM_TASK_SUCCESS,
  };
}
export function claimTaskFailure(failures: Array<IFailure>) {
  return {
    type: ITaskTypes.CLAIM_TASK_FAILURE,
    payload: { failures },
  };
}

export function getTaskFormRequest(task: ITask) {
  return {
    type: ITaskTypes.GET_TASK_FORM_REQUEST,
    payload: { task },
  };
}
export function getTaskFormSuccess(
  id: string,
  form: IProcessXmlFormFieldParsed[],
) {
  return {
    type: ITaskTypes.GET_TASK_FORM_SUCCESS,
    payload: { id, form },
  };
}
export function getTaskFormFailure(id: string) {
  return {
    type: ITaskTypes.GET_TASK_FORM_FAILURE,
    payload: { id },
  };
}

export function getTaskFormHTMLRequest(id: string) {
  return {
    type: ITaskTypes.GET_TASK_FORM_HTML_REQUEST,
    payload: { id },
  };
}
export function getTaskFormHTMLSuccess(id: string, form: string) {
  return {
    type: ITaskTypes.GET_TASK_FORM_HTML_SUCCESS,
    payload: { id, form },
  };
}
export function getTaskFormHTMLFailure(id: string) {
  return {
    type: ITaskTypes.GET_TASK_FORM_HTML_FAILURE,
    payload: { id },
  };
}

export function getTaskFormVariablesRequest(id: string) {
  return {
    type: ITaskTypes.GET_TASK_FORM_VARIABLES_REQUEST,
    payload: { id },
  };
}
export function getTaskFormVariablesSuccess(
  id: string,
  formVariables: ObjectLiteral,
) {
  return {
    type: ITaskTypes.GET_TASK_FORM_VARIABLES_SUCCESS,
    payload: { id, formVariables },
  };
}
export function getTaskFormVariablesFailure(id: string) {
  return {
    type: ITaskTypes.GET_TASK_FORM_VARIABLES_FAILURE,
    payload: { id },
  };
}

export function executeTaskRequest(
  id: string,
  params: IGetTasksParams,
  user: IUser,
  variables: { [key: string]: any },
  processFiles: IProcessFile[],
  rootProcessInstanceId?: string,
) {
  return {
    type: ITaskTypes.EXECUTE_TASK_REQUEST,
    payload: {
      id,
      params,
      user,
      variables,
      processFiles,
      rootProcessInstanceId,
    },
  };
}
export function executeTaskSuccess(id: string) {
  return {
    type: ITaskTypes.EXECUTE_TASK_SUCCESS,
    payload: { id },
  };
}
export function executeTaskFailure() {
  return {
    type: ITaskTypes.EXECUTE_TASK_FAILURE,
  };
}

export function getHistoryTaskRequest(id: string) {
  return {
    type: ITaskTypes.GET_HISTORY_TASK_REQUEST,
    payload: { id },
  };
}
export function getHistoryTaskSuccess(historyTask: ITaskHistory) {
  return {
    type: ITaskTypes.GET_HISTORY_TASK_SUCCESS,
    payload: { historyTask },
  };
}
export function getHistoryTaskFailure() {
  return {
    type: ITaskTypes.GET_HISTORY_TASK_FAILURE,
  };
}

export function getTaskDataChartRequest(params: ObjectLiteral) {
  return {
    type: ITaskTypes.GET_TASK_DATA_CHART_REQUEST,
    payload: { params },
  };
}
export function getTaskDataChartSuccess(tasksDataChart: ITaskData[]) {
  return {
    type: ITaskTypes.GET_TASK_DATA_CHART_SUCCESS,
    payload: { tasksDataChart },
  };
}
export function getTaskDataChartFailure() {
  return {
    type: ITaskTypes.GET_TASK_DATA_CHART_FAILURE,
  };
}

export function getTasksStatusRequest(params: ObjectLiteral) {
  return {
    type: ITaskTypes.GET_TASKS_STATUS_REQUEST,
    payload: { params },
  };
}
export function getTasksStatusSuccess(tasksStatusCount: ITaskData[]) {
  return {
    type: ITaskTypes.GET_TASKS_STATUS_SUCCESS,
    payload: { tasksStatusCount },
  };
}
export function getTasksStatusFailure() {
  return {
    type: ITaskTypes.GET_TASKS_STATUS_FAILURE,
  };
}

export function getCancelingReasonsRequest() {
  return {
    type: ITaskTypes.GET_CANCELING_REASONS_REQUEST,
    payload: {},
  };
}
export function getCancelingReasonsSuccess(
  cancelingReasons: ICancelingReasonData[],
) {
  return {
    type: ITaskTypes.GET_CANCELING_REASONS_SUCCESS,
    payload: { cancelingReasons },
  };
}
export function getCancelingReasonsFailure() {
  return {
    type: ITaskTypes.GET_CANCELING_REASONS_FAILURE,
  };
}

export function getTaskRankingRequest(params: ObjectLiteral) {
  return {
    type: ITaskTypes.GET_TASK_RANKING_REQUEST,
    payload: { params },
  };
}
export function getTaskRankingSuccess(taskRanking: ITaskRankingPosition[]) {
  return {
    type: ITaskTypes.GET_TASK_RANKING_SUCCESS,
    payload: { taskRanking },
  };
}
export function getTaskRankingFailure() {
  return {
    type: ITaskTypes.GET_TASK_RANKING_FAILURE,
  };
}

export function getTaskListByProcessInstanceRequest(processInstanceId: string) {
  return {
    type: ITaskTypes.GET_TASK_LIST_BY_PROCESS_INSTANCE_REQUEST,
    payload: { processInstanceId },
  };
}

export function getTaskListByProcessInstanceSuccess(
  tasks: Array<InstanceLink>,
) {
  return {
    type: ITaskTypes.GET_TASK_LIST_BY_PROCESS_INSTANCE_SUCCESS,
    payload: { tasks },
  };
}

export function getTaskListByProcessInstanceFailure() {
  return {
    type: ITaskTypes.GET_TASK_LIST_BY_PROCESS_INSTANCE_FAILURE,
  };
}

export function getFilterParamsRequest(
  filterParams: ObjectLiteral,
  searchFilter?: string,
) {
  return {
    type: ITaskTypes.GET_FILTER_PARAMS_REQUEST,
    payload: { filterParams, searchFilter },
  };
}

export function getFilterParamsSuccess(
  filterParams: ObjectLiteral,
  searchFilter?: string,
) {
  return {
    type: ITaskTypes.GET_FILTER_PARAMS_SUCCESS,
    payload: { filterParams, searchFilter },
  };
}

export function getFilterParamsFailure() {
  return {
    type: ITaskTypes.GET_FILTER_PARAMS_FAILURE,
  };
}

export function isExecutingTaskRequest() {
  return {
    type: ITaskTypes.IS_EXECUTING_TASK_REQUEST,
  };
}

export function clearFilterParamsRequest() {
  return {
    type: ITaskTypes.CLEAR_FILTER_PARAMS_REQUEST,
  };
}

export function clearSearchFilterRequest() {
  return {
    type: ITaskTypes.CLEAR_SEARCH_FILTER_REQUEST,
  };
}
